<template>
  <v-container class="privatstep5 mb-5 pa-0" fluid>

    <v-row no-gutters>

      <v-col cols="12"
             class="ueber primary--text main--section">
        <span>Rechtliche Hinweise und Angaben</span>
      </v-col>

      <v-col v-if="!aenderung"
             cols="12"
             class="firstsection primary--text">
        <span>Verfahrensvariante</span>
      </v-col>


      <v-row v-if="!aenderung" no-gutters>
          <v-row no-gutters
                 class="flex-nowrap">
                <v-checkbox v-model="invitatio"
                    v-validate.immediate="'required|truthy'"
                    :hide-details="!aenderung"
                    :error-messages="errors.collect('verfahren')"
                    data-vv-as="Vorlage"
                    data-vv-name="verfahren"
                    data-vv-validate-on="none"
                    value="N"
                    name="verfahren"
                    color="primary"
                    class="verfahren-rb pa-0 ma-0"/>
            <div class="form--text radio-label">
                Das individuelle Produktinformationsblatt, die Allgemeinen Vertragsinformationen und die {{ arbTitle }} lagen dem Kunden/der bevollmächtigten Person rechtzeitig vor.*
                 <site-tooltip titel="Stellvertreter-Modell">
                Dieser Abschluss entspricht dem Antrags-Verfahren bzw. dem Stellvertreter-Modell, wenn Sie als Makler berechtigt sind, Willenserklärungen abzugeben und anzunehmen.
              </site-tooltip>
              <v-row v-if="invitatio===null" no-gutters class="red--text ">Die Bestätigung ist verpflichtend</v-row>
            </div>
            <v-spacer />
          </v-row>
          

      </v-row>

      <v-col cols="12"
              class="section primary--text">
        <span>Datenschutzhinweise</span>
      </v-col>

      <v-col cols="12">
        <p class="form--text">
          Mit der Abgabe des Deckungsauftrags werden personenbezogene Daten des Kunden erhoben, die sich aus dem Formular ergeben. Die von Ihnen zur Verfügung gestellten personenbezogenen Daten werden von der DMB Rechtsschutz nur nach den gesetzlichen Vorgaben (insbesondere Bundesdatenschutzgesetz „BDSG“ und Datenschutz-Grundverordnung „DSGVO“) erhoben und verarbeitet. Die DMB Rechtsschutz und ihr Datenschutzbeauftragter sind die verantwortliche Stelle für die Erhebung, Verarbeitung und Nutzung der personenbezogenen Daten.<br> Der Datenschutzbeauftragte der DMB Rechtsschutz ist erreichbar unter: DMB Rechtsschutz-Versicherung AG, Bonner Str. 323, 50968 Köln, per E-Mail: <a href="mailto:datenschutz@dmb-rechtsschutz.de">datenschutz@dmb-rechtsschutz.de</a>.
        </p>
        <p class="form--text">
          Die DMB Rechtsschutz verarbeitet und speichert die personenbezogenen Daten nur im Rahmen der Zweckbestimmung des Versicherungsvertrages gemäß Art. 6 Absatz 1 b) DSGVO. Empfänger der personenbezogenen Daten können für die Beurteilung des Versicherungsrisikos und zur Abwicklung etwaiger Rückversicherungen andere Versicherer und/oder der Gesamtverband der Deutschen Versicherungswirtschaft e.V. sein. Die personenbezogenen Daten werden nur für den Umfang und die Zeit, für die die Speicherung im Sinne des Art. 17 Absatz 1 a) DSGVO notwendig ist und die DMB Rechtsschutz ihre eigenen gesetzlichen Verpflichtungen zu erfüllen hat, gespeichert. Jede betroffene Person hat gegenüber der DMB Rechtsschutz das Recht auf Auskunft nach Art. 15 DSGVO, das Recht auf Berichtigung nach Art. 16 DSGVO, das Recht auf Löschung nach Art. 17 DSGVO, das Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO sowie das Recht auf Datenübertragbarkeit nach Art. 20 DSGVO.
        </p>
      </v-col>

      <v-col cols="12"
              class="section primary--text">
        <span>Bonitätsprüfung</span>
      </v-col>

      <v-col cols="12">
        <p class="form--text">
          Wir übermitteln die Daten des Kunden (Name, Adresse und ggf. Geburtsdatum) zur Beurteilung des Zahlungsausfallrisikos auf Basis mathematisch-statistischer Verfahren unter Verwendung von Anschriftendaten (Bonitätsprüfung) an die infoscore Consumer Data GmbH, Rheinstraße 99, 76532 Baden-Baden bzw. die Creditreform Köln, Gustav-Heinemann-Ufer 68, 50968 Köln. Rechtsgrundlagen dieser Übermittlung sind die Art. 6 Absatz 1 b) und Art. 6 Absatz 1 f) DSGVO. Übermittlungen auf der Grundlage dieser Bestimmungen dürfen nur erfolgen, soweit dies zur Wahrnehmung berechtigter Interessen unseres Unternehmens oder Dritter erforderlich ist und nicht die Interessen der Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz personenbezogener Daten erfordern, überwiegen.
        </p>
      </v-col>

      <v-col cols="12"
              class="section primary--text">
        <span>Einwilligung zu Werbezwecken</span>
      </v-col>

      <v-col cols="12">
        <p class="form--text">
          Wir möchten den Kunden künftig im Rahmen des Versicherungsverhältnisses über weitere Leistungen der DMB Rechtsschutz schriftlich, mündlich, telefonisch oder über andere elektronische Kommunikationsmittel (z. B. Telefax, E-Mail) informieren und beraten. Hierzu bitten wir Sie, uns die Einwilligung für die Nutzung der Kundendaten zu erteilen. Eine einmalig erteilte Einwilligung kann jederzeit für die Zukunft widerrufen werden. Die Abgabe bzw. der Widerruf der Einwilligung hat keinen Einfluss auf den Abschluss des Versicherungsvertrages. Der Widerruf ist zu richten an DMB Rechtsschutz-Versicherung AG, Bonner Straße 323, 50968 Köln, per E-Mail an: <a href="mailto:kundenservice@dmb-rechtsschutz.de">kundenservice@dmb-rechtsschutz.de</a>.<br>
        </p>
      </v-col>

      <v-col cols="12">
        <v-checkbox v-model="werbezwecke"
                    name="werbezwecke"
                    type="checkbox"
                    label="Einwilligung zu Werbezwecken erteilen"
                    value="J"
                    color="primary" />
      </v-col>

    </v-row>

    <v-row no-gutters
           class="stepperbuttons">
      <v-btn color="primary"
             class="standard-button"
             @click="$emit('step-back')">Zurück
      </v-btn>
      <v-spacer />
      <v-btn v-if="!aenderung && angebotfremdPossible"
             color="primary"
             class="standard-button"
             @click="$emit('angebotfremd')">
        Angebot für {{ selectedIdentityVmnr }}
      </v-btn>
      <v-btn v-if="!aenderung"
             color="primary"
             class="standard-button"
             @click="$emit('angebot')">
        Angebot erstellen
      </v-btn>
      <v-btn color="primary"
             class="standard-button"
             :disabled="checkApplicationRight"
             @click="stepForward">{{ aenderung ? 'Änderungen übernehmen' : 'Antrag einreichen' }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import { RIGHTS } from '@/store/user';

export default {
  mixins: [twowayBinding, ValidationMixin, contentLoadingMixin(["ARB", "ARB_SUS", "ARB_YOLIG"])],
  props: {
    aenderung: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapTwoWay([
      "invitatio",
      "werbezwecke",
      "sus",
      "productLine"
    ]),
    arbTitle () {
      if(this.sus) {
        return this.ARB_SUS ? this.ARB_SUS.items[0].title : 'ARB Schnell und Sicher';
      } else if (this.productLine === 'YOLIG') {
        return this.ARB_YOLIG ? this.ARB_YOLIG.items[0].title : 'ARB YOLIG';
      } else{
        return this.ARB ? this.ARB.items[0].title : 'ARB';
      }
    },
    checkApplicationRight () {
       return this.$store.getters.checkAuthorization(RIGHTS.KEINABSCHLUSSBUTTON);
    },
    selectedIdentityVmnr() {
      return this.$store.state[this.statePath].selectedIdentity.vmnr;
    },
    angebotfremdPossible() {
      const mystate = this.$store.state[this.statePath];
      if( (mystate.selectedIdentity.username ?? "") == "") {return false;}
      if( !this.$store.state.user.authorization.roles.includes('fremdangebot')) {return false;}
      if( mystate.selectedIdentity.vmnr == this.$store.state.user.vmnr) {return false;}
      if( mystate.selectedTarif !== mystate.selectedIdentity.tarifname) {return false;}
      return true;
    }
    },
  methods: {
    stepForward() {
      this.$validator.validateAll().then(success => {
        console.log("page valid:" + success);
        if (success){
          this.$emit('step-forward');
        } else {
          if(this.invitatio === false) { this.invitatio = null;}
          this.$emit('step-fail');
        }
      });
    }
  }
};
</script>
<style>
.privatstep5 .main--section {
  margin-bottom: 24px !important;
}

.privatstep5 .firstsection {
  font-size: 20px;
  margin-bottom: 16px !important;
}

.privatstep5 .section {
  font-size: 20px;
  margin-bottom: 16px !important;
  margin-top: 16px !important;
}

.privatstep5 .verfahren-rb label {
  display: none !important;
}

.privatstep5 .verfahren-rb .v-radio {
  max-width: 24px !important;
  max-height: 24px;
  margin-right: 8px !important;
}

.privatstep5 .verfahren-rb .radio-label {
  color: #4a4a4a !important;
}

.privatstep5 .verfahren-rb .error--text {
    color: #0085cf !important;
    caret-color: #0085cf !important;
}

.privatstep5 .form--text {
  font-size: 16px;
}

.privatstep5 .v-input--checkbox {
  margin-top: 16px !important;
  margin-bottom: 0 !important;
  max-width: 100%!important;
}

.privatstep5 .stepperbuttons .v-btn + .v-btn {
  margin-left: 24px !important;
}
</style>